import * as React from "react";
import Modal, { ModalSize } from "../../misc/components/modal";
import { BaseReportImportForm } from "./BaseReportsImportForm";
import { CredentialsForm } from "./CredentialsForm";

export type ReportServerConnectionStatus = null | true | false | "fetching";
export type WizardProgress = "credentials" | "import" | "complete";

export interface BaseReportsProps {
    onClose: () => void;
}

export const BaseReportsWizard = (props: BaseReportsProps) => {
    const [wizardProgress, setWizardProgress] = React.useState<WizardProgress>("credentials");
    const [importResults, setImportResults] = React.useState([]);
    const isSubmittingHook = React.useState(false);
    const [isSubmitting, setIsSubmitting] = isSubmittingHook;

    const [form, setForm] = React.useState(null);

    const FormPage = () => {
        switch (wizardProgress) {
            case "credentials":
                return <CredentialsForm onComplete={(form) => { setForm(form); setWizardProgress("import") }} onCancel={props.onClose} />
            case "import":
                return <BaseReportImportForm setImportResults={setImportResults} importResults={importResults} form={form} />
        }
    }

    return (
        <Modal show={true} size={ModalSize.Large} header="Import Base Reports" closeModalHandler={props.onClose}>
            <div className="modal-body">
                <FormPage />
            </div>
        </Modal>
    );
};
